import { useContext } from "react";
import { AddressAndAccountContext, AddressAndAccountContextType } from "../components/AddressAndAccountProvider/AddressAndAccountProvider";
import useBillingConfig from "./useBillingConfig";
import { useGetConfig } from "./useGetConfig";

/**
 * Custom hook to determine if device ID should be included in billing requests
 * and to get the current device ID when conditions are met
 */
export const useBillingDeviceId = () => {
  const { currentDevice } = useContext(AddressAndAccountContext) as AddressAndAccountContextType;
  const { data: billingConfig, isLoading: billingConfigLoading, error: billingConfigError } = useBillingConfig();
  const { data: config, isLoading: configLoading, error: configError } = useGetConfig();

  // Handle loading states
  const isLoading = billingConfigLoading || configLoading;

  // Handle error states
  const hasError = billingConfigError || configError;

  // Add null checks and default to false for safety
  const billingEnabled = config?.data?.config?.enabled_features?.BILLING?.enabled ?? false;
  const managedBillingEnabled = config?.data?.config?.enabled_features?.MANAGED_BILLING?.enabled ?? false;
  const isStripe = billingConfig?.data?.billing?.config?.billing_system === "STRIPE";

  const shouldIncludeDeviceId = billingEnabled && managedBillingEnabled && isStripe;
  const deviceId = shouldIncludeDeviceId && currentDevice?.id ? currentDevice.id : undefined;

  return {
    shouldIncludeDeviceId,
    deviceId,
    billingEnabled,
    managedBillingEnabled,
    isStripe,
    isLoading,
    hasError,
    billingConfigError,
    configError
  };
};